/* FreshBox search — autosuggest via Shopify predictive search, rendered with our markup. */
(function () {
  var root = document.querySelector('[data-fbsearch]');
  if (!root) return;
  var input = root.querySelector('[data-fbsearch-input]');
  var drop = root.querySelector('[data-fbsearch-drop]');
  var form = root.querySelector('[data-fbsearch-form]');
  var timer = null, ctrl = null, lastQ = '';

  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    return '$' + n.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function esc(s) {
    return (s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function hide() { drop.hidden = true; drop.innerHTML = ''; }
  function show() { drop.hidden = false; }

  function render(q, data) {
    var r = (data.resources && data.resources.results) || {};
    var queries = r.queries || [];
    var collections = r.collections || [];
    var products = r.products || [];

    // build suggestion tags from query suggestions + matching collections (deduped)
    var tags = [], seen = {};
    queries.forEach(function (qq) { var k = (qq.text || '').toLowerCase(); if (k && !seen[k]) { seen[k] = 1; tags.push({ text: qq.text, url: qq.url }); } });
    collections.forEach(function (c) { var k = (c.title || '').toLowerCase(); if (k && !seen[k]) { seen[k] = 1; tags.push({ text: c.title, url: c.url }); } });

    if (!tags.length && !products.length) {
      drop.innerHTML = '<div class="fbsearch__empty">Sin resultados para “' + esc(q) + '”.</div>';
      show(); return;
    }
    var html = '';
    if (tags.length) {
      html += '<div class="fbsearch__sec"><p class="fbsearch__lbl">Sugerencias</p><div class="fbsug__row">';
      tags.slice(0, 6).forEach(function (tg) {
        html += '<a class="fbsug" href="' + esc(tg.url) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>' + esc(tg.text) + '</a>';
      });
      html += '</div></div>';
    }
    if (products.length) {
      html += '<div class="fbsearch__sec"><p class="fbsearch__lbl">Productos</p>';
      products.forEach(function (p) {
        var img = (p.featured_image && (p.featured_image.url || p.featured_image)) || p.image || '';
        var price = parseFloat(p.price);
        var cmp = parseFloat(p.compare_at_price_min || p.compare_at_price || 0);
        var onSale = cmp > price && cmp > 0;
        var meta = '<span class="fbres__price">' + money(p.price) + '</span>';
        if (onSale) {
          var pct = Math.round((1 - price / cmp) * 100);
          meta += '<span class="fbres__was">' + money(cmp) + '</span>';
          if (pct > 0) meta += '<span class="fbres__save">Ahorra ' + pct + '%</span>';
        }
        meta += p.available
          ? '<span class="fbres__stock">En stock</span>'
          : '<span class="fbres__stock out">Agotado</span>';
        html += '<a class="fbres" href="' + esc(p.url) + '">'
          + (img ? '<img class="fbres__thumb" src="' + esc(img) + '" alt="" loading="lazy" />' : '<span class="fbres__thumb"></span>')
          + '<div class="fbres__info"><p class="fbres__name">' + esc(p.title) + '</p>'
          + '<div class="fbres__meta">' + meta + '</div></div></a>';
      });
      html += '</div>';
    }
    html += '<div class="fbsearch__foot"><a href="' + (root.querySelector('[data-fbsearch-form]').action) + '?q=' + encodeURIComponent(q) + '">Ver todos los resultados <span class="arr">&rarr;</span></a><span class="fbsearch__kbd">&crarr; Enter</span></div>';
    drop.innerHTML = html;
    show();
  }

  function fetchSuggest(q) {
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    var url = '/search/suggest.json?q=' + encodeURIComponent(q)
      + '&resources[type]=query,collection,product&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, { signal: ctrl.signal })
      .then(function (res) { return res.json(); })
      .then(function (data) { render(q, data); })
      .catch(function () {});
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    lastQ = q;
    clearTimeout(timer);
    if (q.length < 1) { hide(); return; }
    timer = setTimeout(function () { fetchSuggest(q); }, 180);
  });
  input.addEventListener('focus', function () { if (input.value.trim().length && drop.innerHTML) show(); });
  document.addEventListener('click', function (e) { if (!root.contains(e.target)) hide(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
})();
